import React, { Component } from "react";
import PropTypes from "prop-types";

export const DashboardPage = () => {
  return <div>dashboard here</div>;
};

export default DashboardPage;
